import connectedAuthWrapper from 'redux-auth-wrapper/connectedAuthWrapper';

//Side Menu and Routes permissions
export const showSideMenuUsers = connectedAuthWrapper({
    authenticatedSelector: state => {
        if (state.auth.permissions == null || state.auth.permissions.length <= 0) {
            return false;
        }
        return 'MENU_USERS' in state.auth.permissions
    },
    wrapperDisplayName: 'ShowSideMenuUsers',
});


export const showSideMenuBlocks = connectedAuthWrapper({
    authenticatedSelector: state => {
        if (state.auth.permissions == null || state.auth.permissions.length <= 0) {
            return false;
        }
        return 'MENU_BLOCKS' in state.auth.permissions
    },
    wrapperDisplayName: 'ShowSideMenuBlocks',
});

export const showSideMenuConfiguration = connectedAuthWrapper({
    authenticatedSelector: state => {
        if (state.auth.permissions == null || state.auth.permissions.length <= 0) {
            return false;
        }
        return 'MENU_CONFIGURATION' in state.auth.permissions
    },
    wrapperDisplayName: 'ShowSideMenuConfiguration',
});

export const showSideMenuPages = connectedAuthWrapper({
    authenticatedSelector: state => {
        if (state.auth.permissions == null || state.auth.permissions.length <= 0) {
            return false;
        }
        return 'MENU_PAGES' in state.auth.permissions
    },
    wrapperDisplayName: 'ShowSideMenuPages',
});

//GLOBAL permissions
export const showViewGlobalButton = connectedAuthWrapper({
    authenticatedSelector: state => {
        if (state.auth.permissions == null || state.auth.permissions.length <= 0) {
            return false;
        }
        return 'CONTENT_VIEW' in state.auth.permissions
    },
    wrapperDisplayName: 'showViewGlobalButton',
});

export const showAddGlobalButton = (Component, FailureComponent) => connectedAuthWrapper({
    authenticatedSelector: state => {
        if (state.auth.permissions == null || state.auth.permissions.length <= 0) {
            return false;
        }
        return 'CONTENT_ADD_GLOBAL' in state.auth.permissions
    },
    wrapperDisplayName: 'showAddGlobalButton',
})(Component);

export const showEditGlobalButton = connectedAuthWrapper({
    authenticatedSelector: state => {
        if (state.auth.permissions == null || state.auth.permissions.length <= 0) {
            return false;
        }
        return 'CONTENT_EDIT' in state.auth.permissions
    },
    wrapperDisplayName: 'showEditGlobalButton',
});

export const showDeleteGlobalButton = connectedAuthWrapper({
    authenticatedSelector: state => {
        if (state.auth.permissions == null || state.auth.permissions.length <= 0) {
            return false;
        }
        return 'CONTENT_DELETE_ANY_GLOBAL' in state.auth.permissions
    },
    wrapperDisplayName: 'showDeleteGlobalButton',
});

export const canEditOrViewGlobal = (Component, FailureComponent) => connectedAuthWrapper({
    authenticatedSelector: state => {
        if (state.auth.permissions == null || state.auth.permissions.length <= 0) {
            return false;
        }
        return 'CONTENT_EDIT' in state.auth.permissions
    },
    wrapperDisplayName: 'canEditOrViewGlobal',
    FailureComponent
})(Component);

export const showEnableDisableButton = connectedAuthWrapper({
    authenticatedSelector: state => {
        if (state.auth.permissions == null || state.auth.permissions.length <= 0) {
            return false;
        }
        return 'CONTENT_ENABLE_DISABLE' in state.auth.permissions
    },
    wrapperDisplayName: 'ShowEnableDisableButton',
});

export const showApproveCheckboxes = (Component, FailureComponent) => connectedAuthWrapper({
    authenticatedSelector: state => {
        if (state.auth.permissions == null || state.auth.permissions.length <= 0) {
            return false;
        }
        return 'CONTENT_APPROVE' in state.auth.permissions
    },
    wrapperDisplayName: 'showApproveCheckboxes',
    FailureComponent
})(Component);

//SITE TRANSLATIONS permissions
export const showViewTranslationButton = connectedAuthWrapper({
    authenticatedSelector: state => {
        if (state.auth.permissions == null || state.auth.permissions.length <= 0) {
            return false;
        }
        return 'CONTENT_VIEW_TRANSLATION' in state.auth.permissions
    },
    wrapperDisplayName: 'ShowViewTranslationButton',
});

export const showAddNewTranslationButton = (Component, FailureComponent) => connectedAuthWrapper({
    authenticatedSelector: state => {
        if (state.auth.permissions == null || state.auth.permissions.length <= 0) {
            return false;
        }
        return 'CONTENT_TRANSLATE' in state.auth.permissions
    },
    wrapperDisplayName: 'ShowAddNewTranslationButton',
    FailureComponent: (() => "No actions")
})(Component);

export const showDeleteTranslationButton = connectedAuthWrapper({
    authenticatedSelector: state => {
        if (state.auth.permissions == null || state.auth.permissions.length <= 0) {
            return false;
        }
        return 'CONTENT_DELETE_TRANSLATION' in state.auth.permissions
    },
    wrapperDisplayName: 'ShowDeleteTranslationButton',
});

export const canDeleteTranslationOrNot = (Component, FailureComponent) => connectedAuthWrapper({
    authenticatedSelector: state => {
        if (state.auth.permissions == null || state.auth.permissions.length <= 0) {
            return false;
        }
        return 'CONTENT_DELETE_TRANSLATION' in state.auth.permissions
    },
    wrapperDisplayName: 'CanDeleteTranslationOrNot',
    FailureComponent
})(Component);

export const showEditTranslationButton = connectedAuthWrapper({
    authenticatedSelector: state => {
        if (state.auth.permissions == null || state.auth.permissions.length <= 0) {
            return false;
        }
        return 'CONTENT_EDIT_TRANSLATION' in state.auth.permissions
    },
    wrapperDisplayName: 'ShowEditTranslationButton',
});

export const canEditOrViewTranslation = (Component, FailureComponent) => connectedAuthWrapper({
    authenticatedSelector: state => {
        if (state.auth.permissions == null || state.auth.permissions.length <= 0) {
            return false;
        }
        return 'CONTENT_EDIT_TRANSLATION' in state.auth.permissions
    },
    wrapperDisplayName: 'CanEditOrViewTranslation',
    FailureComponent
})(Component);

export const showApproveTranslationCheckboxes = (Component, FailureComponent) => connectedAuthWrapper({
    authenticatedSelector: state => {
        if (state.auth.permissions == null || state.auth.permissions.length <= 0) {
            return false;
        }
        return 'CONTENT_APPROVE_TRANSLATION' in state.auth.permissions
    },
    wrapperDisplayName: 'ShowApproveTranslationCheckboxes',
    FailureComponent
})(Component);

//REVISIONS permissions
export const showDeleteRevisionButton = connectedAuthWrapper({
    authenticatedSelector: state => {
        if (state.auth.permissions == null || state.auth.permissions.length <= 0) {
            return false;
        }
        return 'CONTENT_DELETE_REVISION' in state.auth.permissions
    },
    wrapperDisplayName: 'ShowDeleteRevisionButton',
});

export const showViewRevisionContentButton = (Component, FailureComponent) => connectedAuthWrapper({
    authenticatedSelector: state => {
        if (state.auth.permissions == null || state.auth.permissions.length <= 0) {
            return false;
        }
        return 'CONTENT_VIEW_REVISIONS' in state.auth.permissions
    },
    wrapperDisplayName: 'ShowViewRevisionContentButton',
})(Component);

export const showViewTranslationRevisionButton = (Component, FailureComponent) => connectedAuthWrapper({
    authenticatedSelector: state => {
        if (state.auth.permissions == null || state.auth.permissions.length <= 0) {
            return false;
        }
        return 'CONTENT_VIEW_TRANSLATION_REVISIONS' in state.auth.permissions
    },
    wrapperDisplayName: 'ShowViewTranslationRevisionButton',
})(Component);

//Users and Roles permissions
export const canAssignRoleToUser = (Component, FailureComponent) => connectedAuthWrapper({
    authenticatedSelector: state => {
        if (state.auth.permissions == null || state.auth.permissions.length <= 0) {
            return false;
        }
        return 'ASSIGN_ROLE_TO_USER' in state.auth.permissions
    },
    wrapperDisplayName: 'CanAssignRoleToUser',
    FailureComponent
})(Component);

export const canAssignPermissionsToRole = (Component, FailureComponent) => connectedAuthWrapper({
    authenticatedSelector: state => {
        if (state.auth.permissions == null || state.auth.permissions.length <= 0) {
            return false;
        }
        return 'ASSIGN_PERMISSION_TO_ROLE' in state.auth.permissions
    },
    wrapperDisplayName: 'CanAssignPermissionsToRole',
    FailureComponent
})(Component);

export const canAdministerPermissions = (Component, FailureComponent) => connectedAuthWrapper({
    authenticatedSelector: state => {
        if (state.auth.permissions == null || state.auth.permissions.length <= 0) {
            return false;
        }
        return 'ADMINISTER_PERMISSION' in state.auth.permissions
    },
    wrapperDisplayName: 'CanAdministerPermissions',
    FailureComponent
})(Component);

//Configuration permissions
export const canAssignReviewsToSites = (Component, FailureComponent) => connectedAuthWrapper({
    authenticatedSelector: state => {
        if (state.auth.permissions == null || state.auth.permissions.length <= 0) {
            return false;
        }
        return 'ASSIGN_REVIEWS_TO_SITES' in state.auth.permissions
    },
    wrapperDisplayName: 'canAssignReviewsToSites',
    FailureComponent
})(Component);


// WEBPACK FOOTER //
// ./src/components/permissions/permissions.js